export default __webpack_public_path__ + "static/media/darjeeling4.36ef0482.jpg";